import React, { PropsWithChildren, useState } from "react";

import HeaderWithSubHeader from "@src/sharedComponents/HeaderWithSubHeader/HeaderWithSubHeader";
import OptionWithExpandCollapseContent from "@src/sharedComponents/OptionWithExpandCollapseContent/OptionWithExpandCollapseContent";

import styles from "./SelectAccounts.module.css";

interface Props {
  showSelectedResourcesDefault?: boolean;
}

const SelectAccounts: React.FC<PropsWithChildren<Props>> = ({
  children,
  showSelectedResourcesDefault = false,
}) => {
  const [showSelectResources, setShowSelectResources] = useState<boolean>(
    showSelectedResourcesDefault
  );

  return (
    <OptionWithExpandCollapseContent
      className={styles.optionWithExpandCollapseContent}
      headerClassName={styles.optionWithExpandCollapseContentHeader}
      expand={showSelectResources}
      collapseRootClassName={
        showSelectResources ? styles.collapseRoot : undefined
      }
      setExpand={setShowSelectResources}
      isLoading={false}
      headerLeftContent={
        <HeaderWithSubHeader
          header={"Accounts"}
          headerClassName={styles.optionHeader}
          subHeader={"Grant access to specific accounts (select one or more)"}
        />
      }
    >
      {children}
    </OptionWithExpandCollapseContent>
  );
};

export default SelectAccounts;
